import { useQuery } from '@tanstack/react-query';
import type { ManagerFiltersType } from '../components/manager/ManagerFilters';
import { managerApi } from '../api';

// export const useManagerQueries = () => {
//   // Get all managers
//   const useManagers = (params?: {
//     page?: number
//     limit?: number
//     search?: string
//     houseId?: string
//   }) => {
//     return useQuery({
//       queryKey: ['managers', params],
//       queryFn: () => managerApi.getManagers(params),
//       staleTime: 5 * 60 * 1000, // 5 minutes
//     });
//   };

//   // Get manager by ID
//   const useManager = (id: string) => {
//     return useQuery({
//       queryKey: ['managers', id],
//       queryFn: () => managerApi.getManagerById(id),
//       enabled: !!id,
//       staleTime: 5 * 60 * 1000, // 5 minutes
//     });
//   };

//   // Get manager statistics
//   const useManagerStats = (managerId: string) => {
//     return useQuery({
//       queryKey: ['managers', managerId, 'stats'],
//       queryFn: () => managerApi.getManagerStats(managerId),
//       enabled: !!managerId,
//       staleTime: 2 * 60 * 1000, // 2 minutes
//     });
//   };

//   // Get available managers (users who can be assigned as managers)
//   const useAvailableManagers = () => {
//     return useQuery({
//       queryKey: ['managers', 'available'],
//       queryFn: () => managerApi.getAvailableManagers(),
//       staleTime: 10 * 60 * 1000, // 10 minutes
//     });
//   };

//   return {
//     useManagers,
//     useManager,
//     useManagerStats,
//     useAvailableManagers,
//   };
// };

/**
 *
 *MANAGER APIS QUERIES HOOK
 *
 */
export const useManagersQuery = (filters: ManagerFiltersType) => {
  return useQuery({
    queryKey: ['managers', filters],
    queryFn: () => managerApi.getManagers(filters),
    select: (res) => res.data, // directly access ApiResponse.data
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (![408, 429].includes(error.response.status)) {
          return false;
        }
      }
      return failureCount < 2;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useManagerDetailQuery = (managerId: string) => {
  return useQuery({
    queryKey: ['manager', managerId],
    queryFn: () => managerApi.getManagerById(managerId),
    enabled: !!managerId, // only run when ID is available
    select: (res) => res.data.manager.manager, // unwrap nested manager field
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error: any) => {
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (![408, 429].includes(error.response.status)) return false;
      }
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
